/**
 * Application configuration
 */

const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  basename: '',
  baseURL: 'https://pharma-outlet.com/api', //prod
  // baseURL: 'http://localhost:3000/api', //test
  rtlLayout: false,
  jwt: {
    secret: 'SECRET-KEY',
    timeout: '1 days',
  },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${config.baseURL}${endpoint}`;
};

// Helper function to get full server URL
export const getServerUrl = (path = '') => {
  return `${config.baseURL}${path}`;
};

export default config;

